import axios, { AxiosRequestConfig } from "axios";
import { store } from "./../../store";
import { setUserToken, initUserFailure } from "../../store/auth/actionCreators";
import { updateCookies, getCookies } from "../../helpers/updateCookies";

import { isTokenExpired } from "../../helpers/token";
import { AuthService } from "../auth";
import { ApiPaths } from "./../api/paths";
import { IErrorType } from "../../store/types/errors.d";

const configureApi = (baseURL?: string) => axios.create({ baseURL });

const api = configureApi(process.env.REACT_APP_API);

const passThrough = [ApiPaths.REFRESH_TOKEN];

api.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const { url } = config;
    const refresh_token = localStorage.getItem("refresh_token");
    const headers: any = config.headers?.common;
    let token = null;
    const { dispatch } = store;

    if (headers) token = headers["x-access-token"];
    if (!token) {
        const { accessToken } = getCookies();
        const storageToken = localStorage.getItem("token");
        token = accessToken || storageToken;
        headers["x-access-token"] = token;
    }
    if (url && passThrough.includes(url as ApiPaths)) return config;

    if (token && refresh_token && isTokenExpired(token)) {
        try {
            delete api.defaults.headers.common["x-access-token"];
            const {
                data: { data: new_token },
            } = await AuthService.refreshToken(refresh_token);
            api.defaults.headers.common["x-access-token"] = new_token;
            dispatch(setUserToken({ token: new_token, refresh_token: refresh_token }));
            updateCookies(new_token, refresh_token);
        } catch (error) {
            dispatch(initUserFailure({ errorType: IErrorType.AXIOS, data: error }));
            //this should be fixed
            localStorage.clear();
            window.open(window.location.origin, "_self");
        }
    }

    return config;
});

export { api };
